<template>
  <el-tooltip
    :value="showValue"
    :disabled="!tip"
    :content="tip"
    placement="top-end"
  >
    <div
      v-track="{
        type: 'click',
        name: `${$route.params.type || 'phone'}.${
          $route.params.step || 'account'
        }.sms`,
      }"
      :class="[
        isActive ? 'active-sms' : '',
        timeCount ? 'disabled' : '',
        'el-input-add-btn',
        theme ? 'theme--' + theme : '',
      ]"
      @click="handle"
    >
      {{ text }}
    </div>
  </el-tooltip>
</template>

<script>
import _throttle from 'lodash/throttle'
import loginSDK from '@/utils/base.js'
import { getBusinessType } from '@/constant'
import { isNeedHandleSMSActive } from '@/utils/consts'

export default {
  name: '',
  props: {
    theme: {
      type: String,
      default: '', // primary 主题色按钮
    },
    tip: {
      type: String,
      default: '',
    },
    from: {
      type: String,
      default: '',
      require: true,
    },
    account: {
      type: [String, Number],
      default: '',
      require: true,
    },
    isActive: {
      type: Boolean,
      default: false,
      require: true,
    },
  },
  data() {
    return {
      times: 0, // 发送次数
      timeCount: 0,
      intervalTime: null,
      showValue: true,
    }
  },

  components: {},

  computed: {
    type() {
      let reg = /^(?:(?:\+|00)86)?1\d{10}$/ //手机号码
      return reg.test(this.account) ? 'phone' : 'email'
    },
    text() {
      return !this.times
        ? getBusinessType().smsTitle
        : this.timeCount > 0
        ? this.timeCount + 's'
        : this.$t('login.loginPage.sendAgain')
    },
    businessType() {
      return getBusinessType().id
    },
  },

  watch: {
    timeCount(v) {
      if (v <= 0) {
        if (isNeedHandleSMSActive()) {
          this.$store.commit('SET_SMSISACTIVE', true)
        }
        clearInterval(this.intervalTime)
      }
    },
  },

  beforeMount() {},

  mounted() {
    setTimeout(() => {
      this.showValue = false
    }, 5000)
  },

  methods: {
    handle: _throttle(
      function () {
        this.$emit('click')
      },
      500,
      { trailing: false }
    ),
    async send() {
      if (!this.from) {
        return
      }

      if (!this.timeCount) {
        // 倒计时
        this.times++
        this.timeCount = 60
        this.intervalTime = setInterval(() => {
          this.timeCount--
        }, 1000)
        try {
          if (this.type === 'email') {
            await this.$api.login.GetEmailCode(this.account)
          } else {
            if (getBusinessType().hasOwnSms) {
              await this.$api.login.GetBusinessPhoneCode(
                this.account,
                getBusinessType().unionId
              )
            } else {
              await this.$api.login.GetPhoneCode(this.account)
            }
          }
          this.$message.success(this.$t('login.loginPage.tokenSent'))
        } catch (error) {
          // 重置 清除定时器
          clearInterval(this.intervalTime)
          this.timeCount = 0
          this.times--
          // 当手机号需要重新绑定，重置当前登录态，跳转到登录页面
          if (
            error.message === 'Phone is registered' ||
            error.message === '手机号已被注册'
          ) {
            loginSDK.logout()
            console.log(this.$route.query)
            setTimeout(() => {
              this.$router.push({
                path: 'login/phone/account',
                query: { ...this.$route.query },
              })
            }, 3000)
          }
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-input-add-btn {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  border: 1px solid #f0f0f3;
  border-radius: 8px;
  background-color: #fff;
  color: #848294;
  font-size: 12px;
  line-height: 24px;
  height: auto;
  min-width: 70px;
  text-align: center;
  padding: 3px 4px;
  z-index: 3;
  cursor: pointer;
  &.theme--primary {
    background: #f0386c;
    color: #fff;
  }
}
.disabled {
  pointer-events: none;
  cursor: default;
}
.active-sms {
  color: #fff;
  background: linear-gradient(
      180deg,
      #e97a89 -14.96%,
      #e24a5e 30.92%,
      #dc253d 100%
    ),
    #d5001c;
}
</style>
<style lang="scss">
.nissan-wrap {
  .el-input-add-btn {
    min-width: auto;
    padding: 3px 10px;
  }
}
</style>
